import styled from 'styled-components';
import { Button } from 'ui';

export const ProfileMenuContainer = styled.div`
  background-color: ${(props) => props.theme.white};
  width: 296px;
  padding-bottom: 8px;
  font-family: ${(props) => props.theme.profileFontFamily};
  cursor: auto;
  hr {
    width: calc(100% + 32px);
    height: 1px;
    border: none;
    background-color: ${(props) => props.theme.profileLineColor};
    margin-left: -16px;
  }
`;

export const WelcomeText = styled.div`
  color: ${(props) => props.theme.profileColor};
  line-height: 1.2;
  font-family: ${(props) => props.theme.profileFontFamilySecondary};
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;

  span {
    font-size: 24px;
  }
`;

export const MenuItem = styled.div`
  padding: 12px 0;
  font-size: 16px;
  font-family: ${(props) => props.theme.profileFontFamilySecondary};
  color: ${(props) => props.theme.profileBlack};

  &:not(:nth-last-of-type(1)) {
    border-bottom: 1px solid ${(props) => props.theme.profileLineColor};
  }

  .profile-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .profile-menu-item-content {
      width: 100%;

      .order-count {
        font-size: 14px;
        padding-left: 5px;
        color: ${(props) => props.theme.profileCount};
      }

      .admin-link {
        display: inline-block;
        width: 100%;
        text-decoration: none;
        color: ${(props) => props.theme.profileBlack};
      }
    }

    .profile-menu-item-icon {
      width: 14px;
      height: 14px;
    }
  }
`;

export const AddCompanyButton = styled(Button)`
  margin-top: 32px;
  width: 100%;
  height: 52px;
  border-radius: 35px;
  font-weight: 700;
  font-size: 14px;
  background-color: ${(props) => props.theme.white};
  color: ${(props) => props.theme.brand01};
  border-color: ${(props) => props.theme.profileAddCompany};
  border-width: 1px;
  font-family: ${(props) => props.theme.profileFontFamilySecondary};
  font-size: 16px;
`;
